import { ApolloError } from "@apollo/client";

/**
 * Récupère le code d'erreur d'une mutation ApolloError.
 * Il faut parser (objet JSON) le retour de l'API pour récupérer le code d'erreur.
 */
export const getDuplicateCheckErrorCode = (error: unknown): string | null => {
  if (!(error instanceof ApolloError)) return null;

  const message = error.graphQLErrors?.[0]?.message;
  if (!message) return null;

  try {
    const parsed = JSON.parse(message) as { errorCode?: string };
    return parsed.errorCode ?? null;
  } catch {
    return null;
  }
};
